import { createFileRoute } from '@tanstack/react-router'
import { FEATURE } from '@trellis/shared'

import { FeatureGate } from '@/components/guards'
import { FeatureDisabledPage } from '@/pages/features/FeatureDisabledPage'
import { AccountingExportSettingsPage } from '@/pages/settings/organization/AccountingExportSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/accounting-export/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <FeatureGate feature={FEATURE.ACCOUNTING_EXPORT} fallback={<FeatureDisabledPage />}>
      <AccountingExportSettingsPage />
    </FeatureGate>
  )
}
